import { FuseNavigationItem } from '@fuse/components/navigation';
import { PERSONAL_SPACE_ROOT } from './workspace.service';

export const PERSONAL_SPACE_GROUP_ID = 'personal-space';

/**
 * « Mon espace » d'un collaborateur qui est aussi une ressource : ses pages de ressource, ouvertes quel
 * que soit son rôle (ses propres données seulement).
 */
export function personalSpaceNavigation(): FuseNavigationItem {
    return {
        id: PERSONAL_SPACE_GROUP_ID,
        title: 'Mon espace',
        subtitle: 'mes CRA, congés et frais',
        type: 'group',
        icon: 'heroicons_outline:user-circle',
        children: [
            item('cra', 'Saisir mon CRA', 'heroicons_outline:clipboard-document-check', '/cra/add'),
            item('cra-history', 'Mes CRA', 'heroicons_outline:clock', '/historique-cra'),
            item('leaves', 'Mes congés', 'heroicons_outline:calendar-days', '/conges/list'),
            item('expenses', 'Mes notes de frais', 'heroicons_outline:receipt-percent', '/note-de-frais'),
            item('documents', 'Mes documents', 'heroicons_outline:document-text', '/fiche/documents'),
        ],
    };
}

function item(id: string, title: string, icon: string, path: string): FuseNavigationItem {
    return { id: `${PERSONAL_SPACE_GROUP_ID}.${id}`, title, type: 'basic', icon, link: PERSONAL_SPACE_ROOT + path };
}
